import {StyleSheet, View, Text} from "react-native";
import {ThemeType} from "@/theming/baseTheme";
import {useCurrentTheme} from "@/theming/useCurrentTheme";
import * as Application from "expo-application";

export function AppVersion() {
    const {theme} = useCurrentTheme();
    const styles = createStyles(theme);
    return (
        <View style={styles.versionContainer}>
            <Text style={styles.versionText}>{Application.nativeApplicationVersion} | {Application.nativeBuildVersion}</Text>
        </View>
    );
}

function createStyles(theme: ThemeType) {
    return StyleSheet.create({
        versionContainer: {
            position: 'absolute',
            bottom: 5,
            right: 15,
            zIndex: 0
        },
        versionText: {
            color: theme.colors.border
        }
    });
}
